import { render } from "./SplashScreen.vue?vue&type=template&id=5ee9886a&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=5ee9886a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ee9886a"

export default script